export default "__VITE_ASSET__Bo_otgwJ__"